/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  DropMePointsResponse,
  DropPointsLeaderboardResponse,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    DropMePointsResponseFromJSON,
    DropMePointsResponseToJSON,
    DropPointsLeaderboardResponseFromJSON,
    DropPointsLeaderboardResponseToJSON,
} from '../models/index';

export interface GetDropsSlugMePointsRequest {
    slug: string;
}

export interface GetDropsSlugPointsLeaderboardRequest {
    slug: string;
    limit?: number;
    offset?: number;
}

/**
 * DropPointsApi - interface
 * 
 * @export
 * @interface DropPointsApiInterface
 */
export interface DropPointsApiInterface {
    /**
     * Authenticated user\'s point balance for a Drop. Returns response with `points` omitted when no transactions yet.
     * @param {string} slug Drop URL slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DropPointsApiInterface
     */
    getDropsSlugMePointsRaw(requestParameters: GetDropsSlugMePointsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropMePointsResponse>>;

    /**
     * Authenticated user\'s point balance for a Drop. Returns response with `points` omitted when no transactions yet.
     */
    getDropsSlugMePoints(requestParameters: GetDropsSlugMePointsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropMePointsResponse>;

    /**
     * Paginated points leaderboard for a Drop. Public endpoint.
     * @param {string} slug Drop URL slug
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DropPointsApiInterface
     */
    getDropsSlugPointsLeaderboardRaw(requestParameters: GetDropsSlugPointsLeaderboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropPointsLeaderboardResponse>>;

    /**
     * Paginated points leaderboard for a Drop. Public endpoint.
     */
    getDropsSlugPointsLeaderboard(requestParameters: GetDropsSlugPointsLeaderboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropPointsLeaderboardResponse>;

}

/**
 * 
 */
export class DropPointsApi extends runtime.BaseAPI implements DropPointsApiInterface {

    /**
     * Authenticated user\'s point balance for a Drop. Returns response with `points` omitted when no transactions yet.
     */
    async getDropsSlugMePointsRaw(requestParameters: GetDropsSlugMePointsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropMePointsResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling getDropsSlugMePoints().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/drops/{slug}/me/points`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DropMePointsResponseFromJSON(jsonValue));
    }

    /**
     * Authenticated user\'s point balance for a Drop. Returns response with `points` omitted when no transactions yet.
     */
    async getDropsSlugMePoints(requestParameters: GetDropsSlugMePointsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropMePointsResponse> {
        const response = await this.getDropsSlugMePointsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Paginated points leaderboard for a Drop. Public endpoint.
     */
    async getDropsSlugPointsLeaderboardRaw(requestParameters: GetDropsSlugPointsLeaderboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropPointsLeaderboardResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling getDropsSlugPointsLeaderboard().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/drops/{slug}/points/leaderboard`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DropPointsLeaderboardResponseFromJSON(jsonValue));
    }

    /**
     * Paginated points leaderboard for a Drop. Public endpoint.
     */
    async getDropsSlugPointsLeaderboard(requestParameters: GetDropsSlugPointsLeaderboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropPointsLeaderboardResponse> {
        const response = await this.getDropsSlugPointsLeaderboardRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
